/// <reference types="facebook-js-sdk" />

import { HttpClient } from '@angular/common/http';
import { HostListener, Injectable } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { GlobalClassInstance } from '@commoncore/constants/GlobalClass';
import { TOAST } from '@commoncore/constants/ToastMessages';
import { LocalStorageSvc } from '@commoncore/services/localStorage.service';
import { UniversalService } from '@commoncore/services/universal.service';
import { ENV_CONSTANTS } from '@env-properties/environment';
import { ENV_CONFIG } from '@env-properties/environment-config';
// import { FacebookService, UIParams, UIResponse } from 'ngx-facebook';

@Injectable({
  providedIn: 'root'
})
export class ReferEarnService {

  referralDetails:any;
  validationError: string= "";
  showReferralAlreadyDone:boolean = false;
  isSourceFromReferral:boolean = false;
  isReferAndEarnLogin: boolean = false;
  @HostListener('window:resize', [])resize(){
    this.setReferraalPopupHeight();
  }
  constructor(
    // private fb: FacebookService, 
    private router:Router, private route:ActivatedRoute,
    private localStorageSvc: LocalStorageSvc,
    private http: HttpClient, private universalService:UniversalService ) { 
   
  }

  getReferralDetails(){
  
    const self = this;

    const url = ENV_CONSTANTS.privateUrls[GlobalClassInstance.ENV_NAME]["securityURL"] + ENV_CONFIG.commonUrls.referralCodeDetails;
    return new Promise((resolve, reject)=>{
      this.http.get(url).subscribe(response => {
        response["refAddedQuota"] = response["inviterQuota"]
        response["inviterQuota"] = response["inviterQuota"];
        response["inviteeQuota"] = response["inviteeQuota"];
        self.referralDetails = response;
        self.localStorageSvc.setReferralCodeDetails(this.referralDetails, true);
        resolve(this.referralDetails);
      }, error=> {
        reject(error);
      })
    })
    
  }

  sendReferralInviteEmail = function(email) {

    let self = this;
    const url = ENV_CONSTANTS.privateUrls[GlobalClassInstance.ENV_NAME]["securityURL"] + ENV_CONFIG.commonUrls.referEarnInvite;
    const data = {
      "recipientEmailId":email
    }

    return new Promise((resolve, reject)=> {
      this.http.post(url,data).subscribe( response => {
        let notificationMessage = TOAST["EMAIL_REFER_AND_EARN"] + email;
        self.universalService.showToast(notificationMessage, 'success');
        resolve(response);
      }, error=> {
        let errorObj = error.error;
        let notificationMessage;
        if (errorObj.code === "TEJVF0002") {
          notificationMessage = TOAST["INVALID_RECIPIENT_EMAIL"];
        } else {
          notificationMessage = TOAST["GENERIC_ERROR"];
        }
        self.universalService.showToast(notificationMessage, 'error')
        reject(error);
      })
    })
         
    
  }
  
  
  referralInviteOnFacebook = function(referralCode) {
    // FB.init({
    //   appId      : ENV_CONSTANTS['fbAppId'],
    //   cookie : true,
    //   version    : 'v18.0'
    // });
    // FB.ui({
    //   method: 'share',
    //   display: 'popup',
    //   href: '/profile/refer/?refercode=' + referralCode,
    // }, function(response){});
  }
  


  validateReferralCode(referralData) {
   
    this.universalService.showLoader = true;
    const url = ENV_CONSTANTS.privateUrls[GlobalClassInstance.ENV_NAME]["securityURL"] + ENV_CONFIG.commonUrls.validateReferralCode;
    return new Promise((resolve,reject)=>{
      this.http.put(url, referralData).subscribe(
        response=>{
          this.universalService.showLoader = false;
          resolve(response)
      },error=>{
        let errorObj = error.error;
        if (errorObj.code == "SCLN0113") {
          errorObj["validationError"] = "Incorrect code, Enter again.";
        } else if (errorObj.code == "SCLN0114") {
          errorObj["validationError"] = "Referrals max limit reached";
        }
        this.universalService.showLoader = false;
        reject(errorObj);
      })
    })
  
  }


  checkReferralStatusAndFlow(){
    const isShowReferral = localStorage.getItem("showReferral");
    const isShowReferralDone = localStorage.getItem("showReferralDone");
    if ( isShowReferral === "true" && isShowReferralDone === "false") {
     this.showReferralAlreadyDone = false;
     this.isSourceFromReferral = true;
     this.showReferralPopup();
     return true;
    } else if ( isShowReferral === "false" && isShowReferralDone === "true") {
      this.showReferralAlreadyDone = true;
      this.showReferralPopup();
    } else {
      this.showReferralAlreadyDone = false;

    }
  }

  showReferralPopup(){
    
    ($('#enterCodeModal')as any).modal('show');
    this.setReferraalPopupHeight();
  }

  setReferraalPopupHeight(){
    setTimeout(()=>{
      if(this.universalService.isMobileDevice){
        let img_cont = (document.querySelector('.enterCodeModalBody')) as any;
        let height = (window.innerHeight- 85).toString() + 'px';
        img_cont.style.height = height;
      }
    },100)
  }

}
